// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 776) return "public/css/build/release-cloudweb-15110-132-0-1.202304201225/errorPage.css";
	// return url for filenames based on template
	return undefined;
};